import { connect } from 'react-redux'

import component from 'components/Routes'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  routes: state.routes
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Routes/containers/RoutesContainer.js